(() => {
  // wenhou
  // window.ShopifyAnalytics.meta.product = { handle: 'classic-coffin-shaped-black-rutilated-quartz-engagement-ring',id: 9143612899624, gid: "gid://shopify/Product/9143612899624", vendor: "StarlandUS", variants:[{id: 48324221600040,name: "Classic Coffin Shaped Black Rutilated Quartz Engagement Ring - 18K RG / Moissanite",price: 131900,public_title: "18K RG / Moissanite",sku: ""}] }
  var s = {
    baseURL: "https://drop-a-hint.fly.dev/api",
    numberOfAttempts: 0,
    shop: null,
    insertButton: !1,
    adminTheme: !1,
    settings: null,
    getInitial: !1,
    language: "en",
    cacheTime: 36081323,
    ProductJSON: null,
    productId: null,
    variantId: null,
    product: null,
    openClickExternal: 1,
    openModalFromLink: !1,
    relatedProductsDone: !1,
    relatedProductsInfo: [],
    custom_message_required: !1,
    nivodaIntegration: !1,
    nivodaProductId: null,
    productInfo: { name: null, detail: null, image: null, type: null, price: null },
    Start: function () {
      console.log("DaH: start1");
      var t = new URLSearchParams(window.location.search),
        t = Object.fromEntries(t.entries()),
        e = window.Shopify,
        e =
          (void 0 !== e && e.shop ? ((s.shop = e.shop), e.designMode && (s.adminTheme = !0)) : ((s.shop = window.location.host), (window.Shopify = {}), (window.Shopify.shop = window.location.host)),
          ((t && t.cleanDah && void 0 !== t.cleanDah && "" !== t.cleanDah) || document.querySelector("#admin-bar-iframe") || window.localStorage.getItem("cleanDah")) && (s.CleanCacheApp(), window.localStorage.setItem("cleanDah", Date.now())),
          t &&
            t.openFrom &&
            void 0 !== t.openFrom &&
            "" !== t.openFrom &&
            !t.dropahintid &&
            setTimeout(function () {
              s.openModalFromLink = !0;
            }, 3e3),
          t && t.clickDaHApp && void 0 !== t.clickDaHApp && "" !== t.clickDaHApp && s.uid(),
          s.shop && window.localStorage && window.localStorage.getItem("dropahintid") && window.localStorage.getItem("trackedCompleteOrderSourceId") && s.GetOrder(window.localStorage.getItem("trackedCompleteOrderSourceId")),
          (window.performance.navigation && 1 === window.performance.navigation.type) ||
            window.performance
              .getEntriesByType("navigation")
              .map((t) => t.type)
              .includes("reload"));
      e && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && "product" === window.ShopifyAnalytics.meta.page.pageType
        ? window.localStorage.getItem("dropahintReload")
          ? (window.localStorage.setItem("dropahintReload", parseInt(window.localStorage.getItem("dropahintReload")) + 1), 4 <= parseInt(window.localStorage.getItem("dropahintReload")) && (console.log("DaH: Removing for 3 refresh"), s.CleanCacheApp()))
          : window.localStorage.setItem("dropahintReload", 1)
        : window.localStorage.removeItem("dropahintReload"),
        s.uid(),
        s.adminTheme && (console.log("DaH: admin Theme"), s.preLoadSetting(!1, !0)),
        s.shop && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product
          ? (console.log("Drop: before calling product"),
            window.ShopifyAnalytics.meta.product.id && (s.productId = window.ShopifyAnalytics.meta.product.id),
            window.ShopifyAnalytics.meta.selectedVariantId && (s.variantId = window.ShopifyAnalytics.meta.selectedVariantId),
            window.ShopifyAnalytics.meta.productId && (s.productId = window.ShopifyAnalytics.meta.productId),
            window.ShopifyAnalytics.meta.variantId && (s.variantId = window.ShopifyAnalytics.meta.variantId),
            t && t.variant && !s.variantId && (s.variantId = t.variant),
            console.log("Drop: before calling getproduct"),
            s.GetProduct(),
            window.localStorage && window.localStorage.getItem("dropahintCacheTime") && (s.cacheTime = parseInt(window.localStorage.getItem("dropahintCacheTime"))),
            window.localStorage && window.localStorage.getItem("dropahintLanguage") && (s.language = window.localStorage.getItem("dropahintLanguage")),
            window.localStorage && window.localStorage.getItem("dropahintInitialData")
              ? (console.log("DaH: lc0"),
                (e = JSON.parse(window.localStorage.getItem("dropahintInitialData"))) && e.initial_html && e.second_html
                  ? ((s.settings = e), s.PlaceButton(e), (!e.custom_message_required && "true" !== e.custom_message_required && "1" !== e.custom_message_required && 1 !== e.custom_message_required) || (s.custom_message_required = !0))
                  : (console.log("DaH: lc1"), s.preLoadSetting(!0, !0)))
              : (console.log("DaH: lc2"), s.preLoadSetting(!0, !0)))
          : s.shop && window.localStorage && !window.localStorage.getItem("dropahintInitialData") && s.preLoadSetting(!0, !0),
        t && t.email_to && void 0 !== t.email_to && "" !== t.email_to && (window.localStorage.setItem("dropahintEmail", t.email_to), window.localStorage.setItem("dropahintType", "Sender"), console.log("D: save hint")),
        t &&
          t.dropahintid &&
          void 0 !== t.dropahintid &&
          "" !== t.dropahintid &&
          s.shop &&
          (console.log("D: infoPage"), (e = JSON.stringify({ shop: s.shop, uniqueId: t.dropahintid, path: "postHintPage" })), fetch(s.baseURL, { body: e, method: "POST", headers: { "Content-Type": "application/json" } }));
    },
    PostInfoPage: function (t = 0, e) {},
    GetOrder: function (t) {
      (t = t.slice(1, t.length - 1)), s.PostInfoPage("order", { orderSourceId: t }), window.localStorage.removeItem("trackedCompleteOrderSourceId");
    },
    CleanCacheApp() {
      window.localStorage.removeItem("dropahintReload"), window.localStorage.removeItem("dropahintInitialData"), window.localStorage.removeItem("dropahintDate"), window.localStorage.removeItem("dropahintCacheTime"), window.localStorage.removeItem("dropahintLanguage");
    },
    preLoadSetting(e = !1, o = !1) {
      s.shop &&
        s.LoadSettings(s.shop, function (t) {
          t && t.initial_html && ((s.settings = t), e && s.saveButtonCookie(t), o) && s.PlaceButton(t);
        });
    },
    SaveProduct: function (t) {
      t && ((s.ProductJSON = t), console.log("D: i0"), s.ProcessProduct());
    },
    ProcessProduct: function () {
      if (s.ProductJSON) {
        (s.product = null), (s.productInfo.name = null), (s.productInfo.detail = null), (s.productInfo.image = null), (s.productInfo.type = null), (s.productInfo.price = null);
        var e = s.ProductJSON;
        let t = null;
        if (
          (s.ProductJSON.title && (s.productInfo.name = s.ProductJSON.title),
          s.ProductJSON.type && (s.productInfo.type = s.ProductJSON.type),
          s.ProductJSON.price && (s.productInfo.price = s.FormatPriceNumber(s.ProductJSON.price)),
          s.ProductJSON.featured_image && s.ProductJSON.featured_image.url
            ? (console.log(s.ProductJSON.featured_image.url),
              !(0 <= s.ProductJSON.featured_image.url.indexOf("https")) && !1 !== s.ProductJSON.featured_image.url.indexOf("//cdn") ? (s.productInfo.image = "https:" + s.ProductJSON.featured_image.url) : (s.productInfo.image = s.ProductJSON.featured_image.url))
            : s.ProductJSON.featured_image &&
              (console.log(s.ProductJSON.featured_image), !(0 <= s.ProductJSON.featured_image.indexOf("https")) && !1 !== s.ProductJSON.featured_image.indexOf("//cdn") ? (s.productInfo.image = "https:" + s.ProductJSON.featured_image) : (s.productInfo.image = s.ProductJSON.featured_image)),
          console.log("D: before options " + s.variantId),
          s.variantId &&
            s.ProductJSON.variants &&
            "mnched.myapi.shopify.com" !== s.shop &&
            "mrs-push.myapi.shopify.com" !== s.shop &&
            "judith-ripka.myapi.shopify.com" !== s.shop &&
            "lazypants.myapi.shopify.com" !== s.shop &&
            "regalrose.myapi.shopify.com" !== s.shop &&
            "maiden-metal.myapi.shopify.com" !== s.shop &&
            "monica-tolan.myapi.shopify.com" !== s.shop &&
            "nyssa-care.myapi.shopify.com" !== s.shop &&
            "simoneandivy.myapi.shopify.com" !== s.shop)
        )
          for (let o = 0; o < s.ProductJSON.variants.length; ++o)
            if (parseInt(s.ProductJSON.variants[o].id) === parseInt(s.variantId)) {
              if (((t = s.ProductJSON.variants[o]), (s.productInfo.price = s.FormatPriceNumber(s.ProductJSON.variants[o].price)), s.ProductJSON.variants[o].featured_image)) {
                for (let t = 0; t < s.ProductJSON.media.length; ++t)
                  if (parseInt(s.ProductJSON.media[t].id) === parseInt(s.ProductJSON.variants[o].featured_image)) {
                    s.productInfo.image = s.ProductJSON.media[t].src;
                    break;
                  }
                s.ProductJSON.variants[o].featured_image.src && (s.productInfo.image = s.ProductJSON.variants[o].featured_image.src);
              }
              if (s.ProductJSON.options) {
                let e = "";
                for (let t = 0; t < s.ProductJSON.options.length; ++t) s.ProductJSON.variants[o]["option" + (t + 1)] && (e += s.ProductJSON.options[t].name + " " + s.ProductJSON.variants[o]["option" + (t + 1)] + ", ");
                (s.productInfo.detail = e.slice(0, -2)), "Title Default Title" === s.productInfo.detail && (s.productInfo.detail = "");
              }
              break;
            }
        s.ProductJSON.detail && (s.productInfo.detail = s.ProductJSON.detail);
        var o = [{}];
        (o[0].body = {}), (o[0].body.product = {}), (o[0].body.product = e), (o[1] = {}), (o[1].body = {}), (o[1].body.variant = {}), (o[1].body.variant = t), (s.product = o), console.log("D: ProcessProduct ok"), s.populateContent(s.productInfo, s.product);
      }
    },
    populateContent: async function (e, t) {
      document.querySelector("#dropahintModals .product_name") &&
        document.querySelectorAll("#dropahintModals .product_name").forEach((t) => {
          t.textContent = e.name;
        }),
        document.querySelector("#dropahintModals .product_detail") &&
          document.querySelectorAll("#dropahintModals .product_detail").forEach((t) => {
            t.textContent = e.detail;
          }),
        document.querySelector("#dropahintModals .product_type") && (document.querySelector("#dropahintModals .product_type").textContent = e.type),
        document.querySelector("#dropahintModals .product_price") && (document.querySelector("#dropahintModals .product_price").textContent = e.price),
        s.getRelatedProducts(),
        document.querySelector(".productImageDropahint") &&
          e &&
          e.image &&
          document.querySelectorAll(".productImageDropahint").forEach((t) => {
            t.setAttribute("src", e.image), s.imgSize(e.image, t);
          }),
        document.querySelector("#dropahintModals") &&
          e &&
          e.image &&
          (document.querySelector("#dropahintModals #u_body") &&
            document.querySelectorAll("#dropahintModals #u_body").forEach((t) => {
              'url("https://drophint-2-files.myshopify.com/cdn/shop/t/1/assets/hinted_product.png")' === t.style.backgroundImage && (t.style.backgroundImage = 'url("' + e.image + '")');
            }),
          document.querySelector("#dropahintModals .container")) &&
          document.querySelectorAll("#dropahintModals .container").forEach((t) => {
            'url("https://drophint-2-files.myshopify.com/cdn/shop/t/1/assets/hinted_product.png")' === t.style.backgroundImage && (t.style.backgroundImage = 'url("' + e.image + '")');
          });
    },
    loadImage: async function (o, n) {
      return new Promise((t, e) => {
        (n.onload = () => t(n)), (n.onerror = e), (n.src = o);
      });
    },
    imgSize: async function (t, e) {
      var o;
      return (
        "string" == typeof t &&
        ((o = document.createElement("img")),
        await s.loadImage(t, o),
        document.body.appendChild(o),
        (t = [o.clientWidth, o.clientHeight]),
        o.remove(),
        e && t[0] < t[1] && "autopx" != (o = JSON.parse(JSON.stringify(e.getAttribute("width"))) + "px") && (e.setAttribute("width", "auto"), e.setAttribute("height", o), (e.style.cssText = "width: auto !important"), (e.style.maxWidth = "100%"), (e.style.height = o)),
        !0)
      );
    },
    getRelatedProducts: async function () {
      if ((s.settings && s.settings.query_cta_third, s.settings && void 0 !== s.settings.query_cta_third && document.querySelector("#dropahintModals #hint_modal_closing .relatedProductImageDropahint") && document.querySelector(s.settings.query_cta_third) && !s.relatedProductsDone)) {
        (s.relatedProductsInfo = []), (s.relatedProductsDone = !0);
        let t = s.settings.query_cta_third + " img";
        ".ProdUpsell .ProdUpsell-grid" === s.settings.query_cta_third && (t = s.settings.query_cta_third + " .ProdUpsell-image"),
          document.querySelectorAll(t).forEach((t, e) => {
            let o = t.getAttribute("src");
            var n;
            t.getAttribute("data-srcset") && t.getAttribute("data-srcset").split(",")[0].split(" ")[0]
              ? ((n = t
                  .getAttribute("data-srcset")
                  .split(",")
                  .map((t) => t.trim())
                  .reduce((t, e) => {
                    var o = parseInt(e.split(" ")[1]);
                    return parseInt(t.split(" ")[1]) < o ? e : t;
                  })),
                (o = n.split(" ")[0]))
              : t.getAttribute("srcset") && t.getAttribute("srcset").split(",")[0].split(" ")[0]
              ? ((n = t
                  .getAttribute("srcset")
                  .split(",")
                  .map((t) => t.trim())
                  .reduce((t, e) => {
                    var o = parseInt(e.split(" ")[1]);
                    return parseInt(t.split(" ")[1]) < o ? e : t;
                  })),
                (o = n.split(" ")[0]))
              : t.getAttribute("data-bgset") &&
                t.getAttribute("data-bgset").split(",")[0].split(" ")[0] &&
                ((n = t
                  .getAttribute("data-bgset")
                  .split(",")
                  .map((t) => t.trim())
                  .reduce((t, e) => {
                    var o = parseInt(e.split(" ")[1]);
                    return parseInt(t.split(" ")[1]) < o ? e : t;
                  })),
                (o = n.split(" ")[0])),
              document.querySelectorAll(s.settings.query_cta_third + " a") && document.querySelectorAll(s.settings.query_cta_third + " a")[e] && s.relatedProductsInfo.push({ src: o, href: document.querySelectorAll(s.settings.query_cta_third + " a")[e].getAttribute("href") });
          }),
          console.log(document.querySelectorAll("#dropahintModals #hint_modal_closing .relatedProductImageDropahint")),
          document.querySelectorAll("#dropahintModals #hint_modal_closing .relatedProductImageDropahint").forEach((t, e) => {
            var o;
            s.relatedProductsInfo[e] && (t.setAttribute("src", s.relatedProductsInfo[e].src), ((o = document.createElement("a")).href = s.relatedProductsInfo[e].href), (o.target = "_blank"), t.parentNode.insertBefore(o, t), o.appendChild(t));
          });
      } else
        document.querySelector("#dropahintModals #hint_modal_closing .relatedProductImageDropahint") &&
          document.querySelectorAll("#dropahintModals #hint_modal_closing .relatedProductImageDropahint").forEach((t) => {
            s.productInfo.image && t.setAttribute("src", s.productInfo.image);
          });
    },
    GetProduct: async function (t = null) {
      var o = window.location.pathname.split("/");
      let n = !1;
      if (o && 0 < o.length) {
        let e = o[o.length - 1];
        // wenhou
        e = window.ShopifyAnalytics.meta.product.handle


        if (("" === e && o[o.length - 2] && (e = o[o.length - 2]), (e = t ? t : e) && "" !== e)) {
          if ((console.log("D: getProduct handle not null " + e), window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.mainProductImage && window.ShopifyAnalytics.meta.mainProductTitle)) {
            console.log("D: getProduct mainProductImage");
            let t = null;
            (n = !0), window.ShopifyAnalytics.meta.mainProductDetail && (t = window.ShopifyAnalytics.meta.mainProductDetail), s.SaveProduct({ title: window.ShopifyAnalytics.meta.mainProductTitle, featured_image: window.ShopifyAnalytics.meta.mainProductImage, detail: t });
          } else {
            console.log("D: getProduct " + window.location.origin + "/products/" + e + ".js");
            let t = await fetch(window.location.origin + "/products/" + e + ".js");
            t.ok
              ? ((n = !0), console.log("D: getProduct ok"), s.SaveProduct(await t.json()))
              : window.ShopifyAnalytics &&
                window.ShopifyAnalytics.meta &&
                window.ShopifyAnalytics.meta.product &&
                window.ShopifyAnalytics.meta.product.handle &&
                (t = await fetch(window.location.origin + "/products/" + window.ShopifyAnalytics.meta.product.handle + ".js")).ok &&
                (console.log("D: getProduct ok"), (n = !0), s.SaveProduct(await t.json()));
          }
          !n &&
            window?.ShopifyAnalytics?.meta?.product?.id &&
            ((o = JSON.stringify({ shop: s.shop, productId: window.ShopifyAnalytics.meta.product.id, path: "getProductHandle" })), (t = await fetch(s.baseURL, { body: o, method: "POST", headers: { "Content-Type": "application/json" } })).ok) &&
            (console.log("D: responseNotFound ok"), (o = await t.json()), console.log("D: handleData", o), o.handle) &&
            (console.log("D: handleData.handle", o.handle), (n = !0), s.GetProduct(o.handle));
        }
      }
    },
    FormatPriceNumber: function (t, e) {
      return (
        void 0 === e && (e = 2),
        (parseInt(t) / 100)
          .toFixed(e)
          .replace(",", ".")
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    },
    insertModals: function (t, e) {
      var o = document.createElement("div");
      (o.id = e), (o.style.display = "none"), document.querySelector("#dropahintModals").appendChild(o), (document.querySelector("#" + e).style.display = "none"), (document.querySelector("#" + e).innerHTML = t);
    },
    PlaceButton: function (e) {
      if ((console.log("DaH: d1"), (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && e.active) || s.adminTheme || document.querySelector("#nivoda-dropahint-cta"))) {
        if ((console.log("DaH: d2"), (s.insertButton = !0), e.theme && e.theme !== window.Shopify.theme.name)) return;
        if (e.avoid_query && document.querySelector(e.avoid_query)) return;
        console.log("DaH: d3");
        var o = document.createElement("div");
        if (((o.id = "dropahint"), e.force_query && s.PlaceButtonByQuery(e, o))) console.log("D: d4q");
        else if (!document.querySelector("#dropahint_wrapper") || (e.avoid_wrapper && "false" !== e.avoid_wrapper && "0" !== e.avoid_wrapper && 0 !== e.avoid_wrapper))
          if (s.PlaceButtonByQuery(e, o)) console.log("D: d4q");
          else {
            var n = [
              "html #dropahint_wrapper",
              "html .single_variation_wrap",
              "html .product-form",
              "html .shopify-product-form",
              "html .product-form__group",
              "html shopify-payment-button",
              "html .product-single__form",
              "html .ProductForm",
              "html .product__submit",
              "html .payment-buttons",
              "html .product-form__cart-submit",
              "html .product-form--atc",
              "html form.product_form",
              "html .f-product-form__buttons",
              "html .product-block",
              "html .payment-and-quantity",
              "html .product-form__buttons",
              "html .product-buy-buttons--form",
              "html #MainPaymentContainer",
              "html .product__section--buttons.product-add",
              "html .product__cart-actions",
              "html .form-actions",
              "html .product__cart-functions",
              "html .quantity-submit-row",
              "html .product__form-buttons",
              "html .product-form__controls-group--submit",
              "html .product-page--submit-action",
              "html .main-product__form-buttons",
              "html .buy-buttons",
              "html .pdp-action-container",
              "html .product-add",
              "html .product__add-inner-container",
              "html button.add-item",
              "html .ProductForm__BuyButtons",
              "html .purchase-section",
              "html .product-add-to-cart-container",
              "html .product-form__cart-buttons",
              "html .product-form__item",
              "html .product__form",
              "html .addtocart-button-active",
              "html .product-buy-buttons--root",
              "html #dynamic-buttons-form",
              "html .buy-buttons__buttons",
              "html product-form.product-form",
              "html #b-buttons",
              "html .product__submit__item",
              "html .w-full",
              "html .buttons-holder-fix",
              "html .paymentButtonsWrapper",
              "html .payment-buttons-container",
              "html .product__submit__buttons",
              "html .purchase-details",
              "html .add-to-cart",
              "html .product-form__payment-container",
              "html .product-add-to-cart",
              "html .product-detail__form__action",
              "html .with-payment-button",
              "html .product-form-add-to-cart",
              "html .product-main-form",
              'html form[x-ref="productForm"]',
              "html .add-to-cart-container",
              "html .product-form-button-container",
              "html .product-form__item--payment-button",
              "html .product-actions",
              "html .atc-btn-container",
              "html .payment-buttons",
              "html .product-form__buttons.product__add-container",
              "html .cta-content",
              "html .shopify-installments-container",
            ];
            let e = !1;
            for (let t = 0; t < n.length; ++t)
              if (document.querySelector(n[t])) {
                document.querySelector(n[t]).appendChild(o), (e = !0);
                break;
              }
            e || document.querySelector("body").appendChild(o);
          }
        else console.log("D: d4w"), document.querySelector("#dropahint_wrapper").appendChild(o);
        if (document.querySelector("#dropahint") && e.initial_html && e.second_html) {
          var a = document.createElement("a"),
            a =
              ((a.href = "https://playground.dropahint.love/"),
              (a.target = "_blank"),
              (a.id = "dropahintInfoLink"),
              (a.style.display = "none"),
              (a.textContent = "Drop a Hint info"),
              (document.querySelector("#dropahint").innerHTML = e.initial_html),
              document.querySelector("#dropahint").prepend(a),
              document.createElement("div"));
          (a.id = "dropahintModals"),
            document.querySelector("html").appendChild(a),
            s.insertModals(e.second_html, "hint_modal"),
            e.third_html && s.insertModals(e.third_html, "hint_modal_closing"),
            e.four_html && s.insertModals(e.four_html, "hint_modal_sms"),
            e.fifth_html && s.insertModals(e.fifth_html, "hint_modal_postal");
          let t =
            "html body #dropahint #dropahintInfoLink {display:none !important;} .smsCardDaH, .emailCardDaH, .postalCardDaH {cursor:pointer; } #u_content_form_postal_your {display: none !important;} #dropahint-cta a, #dropahint-cta a:hover {opacity: 1;} #dropahint-cta .u-row, #dropahint-modal .u-popup-container.fields .u-row, #dropahint-modal .u-popup-container.card .u-row {width: 100%;} #dropahint, #dropahint #dropahint-cta, #dropahint_wrapper {touch-action: initial !important;} #dropahint-cta img{display:inline-block !important; opacity: 1!important;} #hint_modal img, #hint_modal_closing img, #hint_modal_sms img, #hint_modal_postal img {margin: auto !important;} #dropahint-postal form,#dropahint-closing form,#dropahint-modal form {margin-block-end: 0em !important;} #dropahint-postal h2, #dropahint-closing h2,#dropahint-modal h2{display:block;font-size:1.5em;margin-block-start:0.83em;margin-block-end:0.83em;margin-inline-start:0;margin-inline-end:0;font-weight:700;padding:0;text-transform:initial;color:initial;letter-spacing:initial;border:initial}#dropahint-postal input,#dropahint-postal textarea, #dropahint-postal select,#dropahint-closing input,#dropahint-closing textarea,#dropahint-modal input,#dropahint-modal textarea{margin:initial;max-height: 66px;text-indent: 0;line-height: normal;height: auto; overflow: hidden;}#dropahint-modal textarea{min-height: auto !important;}#dropahint-postal input:focus,#dropahint-postal:focus,#dropahint-closing input:focus,#dropahint-closing:focus,#dropahint-modal input:focus,#dropahint-modal:focus{outline:0; box-shadow: none;}#dropahint-postal .container,#dropahint-closing .container,#dropahint-modal .container{padding:initial},#dropahint-modal form{margin-block-end:1em}#dropahint #dropahint-cta #u_body{min-height:auto!important}#dropahint-postal .u-popup-container,#dropahint-closing .u-popup-container,#dropahint-modal .u-popup-container{z-index:99999!important} #dropahint-modal .u-popup-container.fields {z-index: 2147483647 !important;} #dropahint-modal .u-popup-container.fields .u-close-button:hover {color: inherit !important;background-color: inherit !important;} #dropahint-cta .container {width: 100%; padding:0;} .u-close-button .icon-cross {height: 25px !important;width: 25px !important;}.u-close-button .icon-cross:before, .u-close-button .icon-cross:after{height: 1px !important;} #dropahint-modal .u-popup-container.fields div:empty{display: block !important;} #dropahintModals input::placeholder, #dropahintModals textarea::placeholder {opacity: 1 !important;visibility: visible !important;} #dropahintModals .u-popup-overlay {backdrop-filter: blur(6px); display: block;} @media (max-width: 800px) {html #dropahintModals .u-popup-container.card {width: 100% !important;}}";
          e.extra_css && (t += e.extra_css);
          a = document.createElement("style");
          if (
            (document.querySelector("head").appendChild(a),
            (a.innerHTML = t),
            (document.getElementById("dropahint").onclick = function (t) {
              console.log("D: open top"),
                s.PostInfoPage("open Drop Hint"),
                t.preventDefault(),
                window.scrollTo(0, 0),
                e.first_html && "postal" === e.first_html
                  ? (document.getElementById("hint_modal_postal").style.display = "block")
                  : e.first_html && "sms" === e.first_html
                  ? (document.getElementById("hint_modal_sms").style.display = "block")
                  : ((document.getElementById("hint_modal").style.display = "block"), console.log("D: open2 modal and make scroll to top")),
                window.scrollTo(0, 0),
                s.shop && "zb100.myshopify.com" !== s.shop && (document.querySelector("body").style.overflow = "hidden"),
                document.querySelector("#dropahint-closing .u-popup-container") && s.styleModal("#dropahint-closing .u-popup-container", "#dropahint-closing .u-popup-container .u-popup-main", "#dropahint-closing .u-popup-container .u-popup-content"),
                document.querySelector("#dropahint-postal .u-popup-container") && s.styleModal("#dropahint-postal .u-popup-container", "#dropahint-postal .u-popup-container .u-popup-main", "#dropahint-postal .u-popup-container .u-popup-content"),
                document.querySelector("#hint_modal_sms .u-popup-container.fields") && s.styleModal("#hint_modal_sms .u-popup-container.fields", "#hint_modal_sms #dropahint-modal .u-popup-container.fields .u-popup-main", "#hint_modal_sms #dropahint-modal .u-popup-container .u-popup-content"),
                document.querySelector("#hint_modal .u-popup-container.fields") && s.styleModal("#hint_modal .u-popup-container.fields", "#hint_modal #dropahint-modal .u-popup-container.fields .u-popup-main", "#hint_modal #dropahint-modal .u-popup-container .u-popup-content"),
                window.scrollTo(0, 0);
            }),
            window.addEventListener("resize", s.handleResize),
            s.controlModal(s.productInfo, s.product),
            document.querySelector("#dropahint-cta"))
          ) {
            var i = [".productCtaWrapper.dropaHintButton", ".drop-hint-wp", "#cta_dropahint", ".custom-drophint", ".product__hint-button", ".actions .hint", ".leading-5:nth-child(5)", ".hint-btn", "#nivoda-dropahint-cta"];
            for (let t = 0; t < i.length; ++t)
              if (document.querySelector(i[t])) {
                (document.querySelector(i[t]).onclick = function (t) {
                  t.preventDefault(), document.querySelector("#dropahint-cta").click();
                }),
                  document.querySelector("#dropahint-cta") && (document.querySelector("#dropahint-cta").style.display = "none");
                break;
              }
          }
        }
      }
      document.querySelector("#dropahintModals #u_content_button_1_sendHint a") &&
        document.querySelectorAll("#dropahintModals #u_content_button_1_sendHint a").forEach((t) => {
          t.removeAttribute("target"), t.removeAttribute("a"), t.addEventListener("click", r);
        });
    },
    PlaceButtonByQuery: function (t, e) {
      if (t.query_cta) {
        if ("" !== t.query_cta && document.querySelector(t.query_cta) && t.position_button && "" !== t.position_button)
          return "top" === t.position_button ? (console.log("DaH: d4t"), document.querySelector(t.query_cta).prepend(e)) : (console.log("DaH: d4b"), document.querySelector(t.query_cta).appendChild(e)), !0;
        if ("" !== t.query_cta_second && document.querySelector(t.query_cta_second) && t.position_button_second && "" !== t.position_button_second)
          return "top" === t.position_button_second ? document.querySelector(t.query_cta_second).prepend(e) : document.querySelector(t.query_cta_second).appendChild(e), !0;
        if ("" !== t.query_cta_third && document.querySelector(t.query_cta_third) && t.position_button_third && "" !== t.position_button_third)
          return "top" === t.position_button_third ? document.querySelector(t.query_cta_third).prepend(e) : document.querySelector(t.query_cta_third).appendChild(e), !0;
      }
      return !1;
    },
    styleModal: function (t, e, o) {
      (document.querySelector(t).style.height = parseInt(window.innerHeight) + "px"),
        (document.querySelector(t).style.overflow = "scroll"),
        document.querySelector(e) &&
          (s.handleResize(), (t = getComputedStyle(document.querySelector(e)))) &&
          t.maxWidth &&
          ((t = parseInt(t.maxWidth.replace("px"))),
          window.innerWidth >= t
            ? (document.querySelector(o) &&
                document.querySelectorAll(o).forEach((t) => {
                  t.style.overflow = "hidden";
                }),
              document.querySelector("#hint_modal .u-popup-container.fields") &&
                ((document.querySelector("#hint_modal .u-popup-container.fields").style.background = "initial !important"), (document.querySelector("#hint_modal .u-popup-container.fields .u-popup-overlay").style.display = "block !important")))
            : (("#dropahint-closing .u-popup-container .u-popup-main" !== e && "#dropahint-postal .u-popup-container .u-popup-main" !== e) || (document.querySelector(e).style.height = "100%"),
              document.querySelector("#hint_modal .u-popup-container.fields") &&
                ((document.querySelector("#hint_modal .u-popup-container.fields").style.background = "white !important"), (document.querySelector("#hint_modal .u-popup-container.fields .u-popup-overlay").style.display = "none !important"))));
    },
    buttonsPosition: function () {
      var t, e, o;
      document.querySelector("#dropahintModals #u_content_button_1_sendHint a") &&
        (document.querySelector(".sendhintButtonFields") ||
          ((o = document.createElement("span")).classList.add("sendhintButtonFields"),
          (o.style.display = "none"),
          (e = document.querySelector("#dropahintModals #u_content_button_1_sendHint").parentNode),
          (t = document.querySelector("#dropahintModals #u_content_button_1_sendHint")),
          e.insertBefore(o, t)),
        !document.querySelector(".sendhintButtonCard") &&
          document.querySelector("#dropahintModals .u-popup-container.card .u_row:last-child .container") &&
          ((e = document.createElement("span")).classList.add("sendhintButtonCard"), (e.style.display = "none"), document.querySelector("#dropahintModals .u-popup-container.card .u_row:last-child .container").appendChild(e)),
        !(window.innerWidth && window.innerWidth <= 800) || s.settings.cta_mobile_top
          ? document.querySelector(".sendhintButtonFields").parentNode.appendChild(document.querySelector("#dropahintModals #u_content_button_1_sendHint"))
          : (((o = document.querySelector("#dropahintModals #u_content_button_1_sendHint")).style.width = "100%"), document.querySelector(".sendhintButtonCard").parentNode.appendChild(o)));
    },
    handleResize: function () {
      s.buttonsPosition(),
        document.querySelector("#dropahint-closing .u-popup-container") && (document.querySelector("#dropahint-closing .u-popup-container").style.height = parseInt(window.innerHeight) + "px"),
        document.querySelector("#dropahint-postal .u-popup-container") && (document.querySelector("#dropahint-postal .u-popup-container").style.height = parseInt(window.innerHeight) + "px"),
        document.querySelector("#hint_modal .u-popup-container.fields") && (document.querySelector("#hint_modal .u-popup-container.fields").style.height = parseInt(window.innerHeight) + "px"),
        document.querySelector("#hint_modal_sms .u-popup-container.fields") && (document.querySelector("#hint_modal_sms .u-popup-container.fields").style.height = parseInt(window.innerHeight) + "px");
    },
    controlModal: async function (t, e) {
      try {
        var o, n;
        (document.querySelector("#dropahintModals").innerHTML = document.querySelector("#dropahintModals").innerHTML.replaceAll("{{product_name}}", '<span class="product_name"></span>')),
          (document.querySelector("#dropahintModals").innerHTML = document.querySelector("#dropahintModals").innerHTML.replaceAll("{{product_detail}}", '<span class="product_detail"></span>')),
          (document.querySelector("#dropahintModals").innerHTML = document.querySelector("#dropahintModals").innerHTML.replaceAll("{{product_type}}", '<span class="product_type"></span>')),
          (document.querySelector("#dropahintModals").innerHTML = document.querySelector("#dropahintModals").innerHTML.replaceAll("{{product_price}}", '<span class="product_price"></span>')),
          (document.querySelector("#dropahintModals").innerHTML = document.querySelector("#dropahintModals").innerHTML.replaceAll("{{sender_name}}", '<span class="sender_name"></span>')),
          (document.querySelector("#dropahintModals").innerHTML = document.querySelector("#dropahintModals").innerHTML.replaceAll("{{sender_email}}", '<span class="sender_email"></span>')),
          (document.querySelector("#dropahintModals").innerHTML = document.querySelector("#dropahintModals").innerHTML.replaceAll("{{receiver_name}}", '<span class="receiver_name"></span>')),
          (document.querySelector("#dropahintModals").innerHTML = document.querySelector("#dropahintModals").innerHTML.replaceAll("{{receiver_email}}", '<span class="receiver_email"></span>')),
          (document.querySelector("#dropahintModals").innerHTML = document.querySelector("#dropahintModals").innerHTML.replaceAll("{{custom_message}}", '<span class="custom_message"></span>')),
          document.querySelector('input[name="your_name"]') &&
            document.querySelectorAll('input[name="your_name"]').forEach((t) => {
              t.addEventListener("input", l);
            }),
          document.querySelector('input[name="your_email"]') &&
            document.querySelectorAll('input[name="your_email"]').forEach((t) => {
              t.addEventListener("input", c);
            }),
          document.querySelector('input[name="receiver_name"]') &&
            document.querySelectorAll('input[name="receiver_name"]').forEach((t) => {
              t.addEventListener("input", u);
            }),
          document.querySelector('input[name="receiver_email"]') &&
            document.querySelectorAll('input[name="receiver_email"]').forEach((t) => {
              t.addEventListener("input", p);
            }),
          document.querySelector('textarea[name="custom_text"]') &&
            document.querySelectorAll('textarea[name="custom_text"]').forEach((t) => {
              t.setAttribute("maxlength", "80"), t.addEventListener("input", m);
            }),
          document.querySelector("#dropahintModals .u-close-button") &&
            document.querySelectorAll("#dropahintModals .u-close-button").forEach((t) => {
              t.addEventListener("click", d);
            }),
          document.querySelector("[onclick=\"document.querySelector('.u-popup-container').style.display ='none';\"]") &&
            ((o = document.querySelector("[onclick=\"document.querySelector('.u-popup-container').style.display ='none';\"]")), document.querySelector("[onclick=\"document.querySelector('.u-popup-container').style.display ='none';\"]").addEventListener("click", d), o.removeAttribute("onclick")),
          document.querySelector("[onclick=\"document.querySelector('#dropahint-closing .u-popup-container').style.display =$1'=$1none';\"]") &&
            ((n = document.querySelector("[onclick=\"document.querySelector('#dropahint-closing .u-popup-container').style.display =$1'=$1none';\"]")),
            document.querySelector("[onclick=\"document.querySelector('#dropahint-closing .u-popup-container').style.display =$1'=$1none';\"]").addEventListener("click", d),
            n.removeAttribute("onclick")),
          document.querySelector(".smsCardDaH") &&
            document.querySelectorAll(".smsCardDaH").forEach((t) => {
              t.addEventListener("click", a);
            }),
          document.querySelector(".emailCardDaH") &&
            document.querySelectorAll(".emailCardDaH").forEach((t) => {
              t.addEventListener("click", i);
            }),
          document.querySelector(".postalCardDaH") &&
            document.querySelectorAll(".postalCardDaH").forEach((t) => {
              t.addEventListener("click", r);
            }),
          document.querySelector("#hint_modal_closing a") &&
            document.querySelectorAll("#hint_modal_closing a").forEach((t) => {
              t.getAttribute("href") &&
                "" !== t.getAttribute("href") &&
                "#" !== t.getAttribute("href") &&
                void 0 !== t.getAttribute("href") &&
                (0 <= t.getAttribute("href").indexOf("?") ? t.setAttribute("href", t.getAttribute("href") + "&openFrom=dropahint") : t.setAttribute("href", t.getAttribute("href") + "?openFrom=dropahint"));
            });
      } catch (t) {
        console.error(t);
      }
      function a(t) {
        d(t), (document.querySelector("body").style.overflow = "hidden"), (document.getElementById("hint_modal_sms").style.display = "block");
      }
      function i(t) {
        d(t), (document.querySelector("body").style.overflow = "hidden"), (document.getElementById("hint_modal").style.display = "block");
      }
      function r(t) {
        d(t), (document.querySelector("body").style.overflow = "hidden"), (document.getElementById("hint_modal_postal").style.display = "block");
      }
      function d(t) {
        console.log("D: close modal"),
          t.preventDefault(),
          s.PostInfoPage("close Drop Hint"),
          document.getElementById("hint_modal") && (document.getElementById("hint_modal").style.display = "none"),
          document.getElementById("hint_modal_closing") && (document.getElementById("hint_modal_closing").style.display = "none"),
          document.getElementById("hint_modal_sms") && (document.getElementById("hint_modal_sms").style.display = "none"),
          document.getElementById("hint_modal_postal") && (document.getElementById("hint_modal_postal").style.display = "none"),
          (document.querySelector("body").style.overflow = "initial");
      }
      function l(e) {
        document.querySelector(".sender_name") &&
          document.querySelectorAll(".sender_name").forEach((t) => {
            t.textContent = e.target.value;
          });
      }
      function c(e) {
        document.querySelector(".sender_email") &&
          document.querySelectorAll(".sender_email").forEach((t) => {
            t.textContent = e.target.value;
          });
      }
      function u(e) {
        document.querySelector(".receiver_name") &&
          document.querySelectorAll(".receiver_name").forEach((t) => {
            t.textContent = e.target.value;
          });
      }
      function p(e) {
        document.querySelector(".receiver_email") &&
          document.querySelectorAll(".receiver_email").forEach((t) => {
            t.textContent = e.target.value;
          });
      }
      function m(e) {
        document.querySelector(".custom_message") &&
          document.querySelectorAll(".custom_message").forEach((t) => {
            t.textContent = e.target.value;
          });
      }
      s.populateContent(t, e);
    },
    LoadSettings: async function (t, e) {
      console.log("DaH: Loading Data"),
        s.getInitial || ((s.getInitial = !0), (t = await fetch(s.baseURL, { method: "POST", body: JSON.stringify({ shop: t, language: s.language, path: "getInitialData" }), headers: { "Content-Type": "application/json" } })).ok && ((s.getInitial = !1), e(await t.json())));
    },
    saveButtonCookie: function (t) {
      window.localStorage &&
        t &&
        (window.localStorage.setItem("dropahintDate", Date.now()),
        window.localStorage.setItem("dropahintInitialData", JSON.stringify(t)),
        t.cache_time ? (window.localStorage.setItem("dropahintCacheTime", t.cache_time), (s.cacheTime = parseInt(t.cache_time))) : window.localStorage.setItem("dropahintCacheTime", s.cacheTime),
        t.language ? (window.localStorage.setItem("dropahintLanguage", t.language), (s.language = t.language)) : window.localStorage.setItem("dropahintLanguage", s.language));
    },
    uid: function () {
      console.log("DaH: uid");
      let t = Date.now().toString(36) + Math.random().toString(36).substr(2);
      var e = new URLSearchParams(window.location.search),
        e = Object.fromEntries(e.entries());
      return (
        e && e.dropahintid && void 0 !== e.dropahintid && "" !== e.dropahintid ? ((t = e.dropahintid), window.localStorage.setItem("dropahintid", t)) : window.localStorage.getItem("dropahintid") ? (t = window.localStorage.getItem("dropahintid")) : window.localStorage.setItem("dropahintid", t),
        window.localStorage.getItem("dropahintDate") ? parseInt(window.localStorage.getItem("dropahintDate")) + s.cacheTime < parseInt(Date.now()) && (console.log("DaH: getNewData"), s.preLoadSetting(!0, !1)) : (console.log("DaH: uid - no date"), s.preLoadSetting(!0, !0)),
        t
      );
    },
  };
  window.dropahint_s = s;

  function r(a) {
    a.preventDefault(), s.PostInfoPage("send Hint");
    let i = "email",
      r = "#hint_modal ";
    if (
      (document.querySelector("#dropahintModals #hint_modal_sms") && "block" === document.querySelector("#dropahintModals #hint_modal_sms").style.display && ((i = "sms"), (r = "#hint_modal_sms ")),
      document.querySelector("#dropahintModals #hint_modal_postal") && "block" === document.querySelector("#dropahintModals #hint_modal_postal").style.display)
    ) {
      (i = "postal"), (r = "#hint_modal_postal "), (document.querySelector(r + 'input[name="your_email"]').value = s.shop + "@dropahint.love"), (document.querySelector(r + 'input[name="your_name"]').value = s.shop);
      let t = "";
      document.querySelector('#hint_modal_postal input[name="receiver_name"]') && "" !== document.querySelector('#hint_modal_postal input[name="receiver_name"]').value && (t += document.querySelector('#hint_modal_postal input[name="receiver_name"]').value + ";"),
        document.querySelector('#hint_modal_postal input[name="street"]') && "" !== document.querySelector('#hint_modal_postal input[name="street"]').value && (t += document.querySelector('#hint_modal_postal input[name="street"]').value),
        document.querySelector('#hint_modal_postal input[name="street_2"]') && "" !== document.querySelector('#hint_modal_postal input[name="street_2"]').value && (t += ", " + document.querySelector('#hint_modal_postal input[name="street_2"]').value),
        document.querySelector('#hint_modal_postal input[name="city"]') && "" !== document.querySelector('#hint_modal_postal input[name="city"]').value && (t += ";" + document.querySelector('#hint_modal_postal input[name="city"]').value),
        document.querySelector('#hint_modal_postal select[name="state"]') && "" !== document.querySelector('#hint_modal_postal select[name="state"]').value && (t += ", " + document.querySelector('#hint_modal_postal select[name="state"]').value),
        document.querySelector('#hint_modal_postal input[name="zip_code"]') && "" !== document.querySelector('#hint_modal_postal input[name="zip_code"]').value && (t += " " + document.querySelector('#hint_modal_postal input[name="zip_code"]').value),
        (document.querySelector(r + 'input[name="receiver_email"]').value = t);
    }
    if ("" !== document.querySelector(r + 'input[name="your_email"]').value && "" !== document.querySelector(r + 'input[name="receiver_email"]').value)
      if (s.custom_message_required && document.querySelector(r + 'textarea[name="custom_text"]') && "" === document.querySelector(r + 'textarea[name="custom_text"]').value) alert("Please fill all the fields");
      else if (
        "" !== document.querySelector(r + 'input[name="receiver_name"]').value &&
        "" !== document.querySelector(r + 'input[name="your_name"]').value &&
        "" !== document.querySelector(r + 'input[name="receiver_email"]').value &&
        "" !== document.querySelector(r + 'input[name="your_email"]').value
      ) {
        let t = " ",
          e = (document.querySelector(r + 'textarea[name="custom_text"]') && document.querySelector(r + 'textarea[name="custom_text"]').value && (t = document.querySelector(r + 'textarea[name="custom_text"]').value), document.querySelector(r + 'input[name="receiver_email"]').value),
          o = document.querySelector(r + 'input[name="your_email"]').value,
          n = null;
        if ("sms" === i) {
          (e = document.querySelector('select[name="receiver_preffix"]').value + e), (o = document.querySelector('select[name="your_preffix"]').value + o), (n = "SEN" + Date.now().toString(36) + Math.random().toString(36).substring(2, 7));
          let t = window.location.href;
          t = (t = (t += t.includes("?") ? "&" : "?") + ("utm_source=dropahint&dropahintid=" + n)) + ("&email_to=" + e);
          a = `sms:${e}&body=Hello ${document.querySelector(r + 'input[name="receiver_name"]').value}, ${document.querySelector(r + 'input[name="your_name"]').value} asked us to send you this hint! ` + encodeURIComponent(t);
          window.open(a, "_blank");
        }
        a = JSON.stringify({
          type: i,
          productId: s.productId,
          variantId: s.variantId,
          shop: s.shop,
          card_type: window.innerWidth && window.innerWidth <= 800 ? "mobile" : "desktop",
          product: s.product,
          received_name: document.querySelector(r + 'input[name="receiver_name"]').value,
          sender_name: document.querySelector(r + 'input[name="your_name"]').value,
          received_email: e,
          sender_email: o,
          custom_message: t,
          uniqueId: s.uid(),
          product_image: s.productInfo.image,
          product_name: s.productInfo.name,
          product_detail: s.productInfo.detail,
          link: window.location.href,
          language: s.language,
          path: "postSentHint",
          token_to: n,
        });
        fetch(s.baseURL, { body: a, method: "POST", headers: { "Content-Type": "application/json" } }),
          document.getElementById("hint_modal") && (document.getElementById("hint_modal").style.display = "none"),
          document.getElementById("hint_modal_sms") && (document.getElementById("hint_modal_sms").style.display = "none"),
          document.getElementById("hint_modal_postal") && (document.getElementById("hint_modal_postal").style.display = "none"),
          document.getElementById("hint_modal_closing") &&
            (window.scrollTo(0, 0), (document.querySelector("#hint_modal_closing").style.display = "block"), (s.relatedProductsDone = !1), s.getRelatedProducts(), (document.querySelector("body").style.overflow = "hidden"), "kate-kole.myshopify.com" === s.shop) &&
            (document.getElementById("hint_modal") && (document.getElementById("hint_modal").style.display = "none"),
            document.getElementById("hint_modal_closing") && (document.getElementById("hint_modal_closing").style.display = "none"),
            document.getElementById("hint_modal_sms") && (document.getElementById("hint_modal_sms").style.display = "none"),
            document.getElementById("hint_modal_postal") && (document.getElementById("hint_modal_postal").style.display = "none"),
            (document.querySelector("body").style.overflow = "initial")),
          document.querySelector(".u-popup-main .allHeight") &&
            document.querySelector(".u-popup-main .allHeight .u-row") &&
            document.querySelector(".u-popup-main .allHeight").parentElement &&
            getComputedStyle(document.querySelector(".u-popup-main .allHeight").parentElement) &&
            getComputedStyle(document.querySelector(".u-popup-main .allHeight").parentElement).height &&
            (document.querySelector(".u-popup-main .allHeight .u-row").style.height = getComputedStyle(document.querySelector(".u-popup-main .allHeight").parentElement).height);
        try {
          Shopify.analytics && Shopify.analytics.visitor({ email: o }, { appId: "5645035" });
        } catch (t) {
          console.log("DaH: error", t);
        }
      } else alert("Please fill all the fields");
    else alert("Please check email address");
  }
  setInterval(function () {
    var t = new URLSearchParams(window.location.search);
    let e = Object.fromEntries(t.entries());
    if (
      (s.nivodaIntegration && s.nivodaProductId && e.diamondAddedId && s.nivodaProductId !== e.diamondAddedId && (console.log("D: nivodaProductId changed"), (s.nivodaProductId = e.diamondAddedId), s.Start()),
      window.ShopifyAnalytics && window.ShopifyAnalytics.meta && "" === window.ShopifyAnalytics.meta.selectedVariantId && (window.ShopifyAnalytics.meta.selectedVariantId = 1),
      e && e.variant && !window.ShopifyAnalytics.meta.selectedVariantId && !window.ShopifyAnalytics.meta.variantId && (console.log("D: i0"), (window.ShopifyAnalytics.meta.selectedVariantId = e.variant), (s.variantId = e.variant), s.ProcessProduct()),
      e &&
        e.variant &&
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.selectedVariantId &&
        parseInt(window.ShopifyAnalytics.meta.selectedVariantId) !== parseInt(e.variant) &&
        (console.log("D: i1"), (window.ShopifyAnalytics.meta.selectedVariantId = e.variant), (s.variantId = e.variant), s.ProcessProduct()),
      null !== s.variantId &&
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.selectedVariantId &&
        parseInt(window.ShopifyAnalytics.meta.selectedVariantId) !== parseInt(s.variantId) &&
        (console.log("D: i2"), (s.variantId = window.ShopifyAnalytics.meta.selectedVariantId), s.ProcessProduct()),
      null === s.variantId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId && (console.log("D: i25"), (s.variantId = window.ShopifyAnalytics.meta.selectedVariantId), s.ProcessProduct()),
      null !== s.productId &&
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product &&
        window.ShopifyAnalytics.meta.product.id &&
        parseInt(window.ShopifyAnalytics.meta.product.id) !== parseInt(s.productId) &&
        (console.log("D: i3"), (s.productId = window.ShopifyAnalytics.meta.product.id), (s.product = null), s.GetProduct()),
      null !== s.productId &&
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.product &&
        window.ShopifyAnalytics.meta.productId &&
        parseInt(window.ShopifyAnalytics.meta.productId) !== parseInt(s.productId) &&
        (console.log("D: i4"), (s.productId = window.ShopifyAnalytics.meta.productId), (s.product = null), s.GetProduct()),
      null !== s.variantId &&
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.meta.variantId &&
        parseInt(window.ShopifyAnalytics.meta.variantId) !== parseInt(s.variantId) &&
        (console.log("D: i5"), (s.variantId = window.ShopifyAnalytics.meta.variantId), s.ProcessProduct()),
      null === s.productInfo.image && document.querySelector("#nivoda-dropahint-cta") && document.querySelector(".diamond-proxy-view-details-wrapper .gmfham img"))
    ) {
      console.log("D: i6"), (s.nivodaIntegration = !0), s.preLoadSetting(!0, !0);
      let t = new URLSearchParams(window.location.search);
      (s.productId = t.get("settingId")),
        (s.variantId = t.get("settingVariantId")),
        (s.nivodaProductId = t.get("diamondAddedId")),
        window.ShopifyAnalytics.meta && !window.ShopifyAnalytics.meta.product && (window.ShopifyAnalytics.meta.product = {}),
        (window.ShopifyAnalytics.meta.product.id = s.productId),
        (window.ShopifyAnalytics.meta.variantId = s.variantId),
        s.GetProduct();
    }
    if (
      s.productInfo &&
      null !== s.productInfo.image &&
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.mainProductImage &&
      window.ShopifyAnalytics.meta.mainProductImage !== s.productInfo.image &&
      (console.log("D: iTest6"), window.ShopifyAnalytics) &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.mainProductImage &&
      window.ShopifyAnalytics.meta.mainProductTitle
    ) {
      let t = null;
      window.ShopifyAnalytics.meta.mainProductDetail && (t = window.ShopifyAnalytics.meta.mainProductDetail), s.SaveProduct({ title: window.ShopifyAnalytics.meta.mainProductTitle, featured_image: window.ShopifyAnalytics.meta.mainProductImage, detail: t });
    }
    s && s.settings && s.settings.query_cta_third && "string" == typeof s.settings.query_cta_third && !s.relatedProductsDone && document.querySelector(s.settings.query_cta_third) && s.getRelatedProducts(),
      !s.insertButton ||
        document.querySelector("#dropahint") ||
        s.adminTheme ||
        (s.numberOfAttempts < 7
          ? (console.log("D: Checking CTA not in place"), ++s.numberOfAttempts, s.Start())
          : 7 <= s.numberOfAttempts &&
            setTimeout(function () {
              console.log("D: Checking CTA not in place +5"), ++s.numberOfAttempts, s.Start();
            }, 3e3)),
      !s.adminTheme &&
        !document.querySelector("#dropahint") &&
        window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta &&
        window.ShopifyAnalytics.quickbuy &&
        window.ShopifyAnalytics.meta.product &&
        (window.ShopifyAnalytics.meta.product.id || window.ShopifyAnalytics.meta.productId) &&
        s.numberOfAttempts < 10 &&
        (++s.numberOfAttempts, s.Start()),
      s.openModalFromLink && (document.querySelector("#dropahint-cta").click(), s.PostInfoPage("open Drop Hint"), (s.openModalFromLink = !1)),
      Shopify && Shopify.locale && Shopify.locale !== s.language && ((s.language = Shopify.locale), s.CleanCacheApp(), s.Start());
  }, 500);
    // window.dropahint_s.Start();
})();
